var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar",attrs:{"src":_vm.userIcon,"alt":""},on:{"click":_vm.navigateToUser}})}
var staticRenderFns = []

export { render, staticRenderFns }